import { JSON as TaJson } from 'ta-json-x';
export class JsonThingConverter {
    constructor(typeFn) {
        this.type = typeFn;
    }
    serialize(property) {
        return TaJson.serialize(property);
    }
    deserialize(value) {
        if (typeof value === 'string') {
            const c = new this.type();
            c.name = value;
            return c;
        }
        else {
            return TaJson.deserialize(value, this.type);
        }
    }
    collapseArrayWithSingleItem() {
        /* istanbul ignore next */
        return true;
    }
}
//# sourceMappingURL=thing-json-converter.js.map